import axios from 'axios';
import cfac22 from '../../cfac22';

export const logout = async () => {
  try {
    const endpoint = `${cfac22('MICROSERVICES')}/auth/logout`;
    const { data } = await axios.post(endpoint, null, {
      withCredentials: true,
      headers: {
        'Full-Url': window.location.href,
      },
    });

    const { success, result, error } = data;

    if (!success) {
      return {
        success: false,
        error: error || 'Erro ao realizar logout',
      };
    }

    const { sessionId, message } = result;

    return {
      success: true,
      data: {
        sessionId,
        message,
      },
    };
  } catch (error) {
    throw error?.response?.data || error;
  }
};
